import './style.scss';

// Custom blocks — frontend view scripts
import './blocks/amp/ImageHover/front';
import './blocks/amp/Sticky/StickyZone/front';

window.addEventListener('load', () => {
  const pageTemplate = document.querySelector('.wp-site-blocks');
  if (!pageTemplate) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle('is-visible', entry.isIntersecting);
      });
    },
    { rootMargin: '0px 0px -20% 0px', threshold: 0 }
  );

  // Read height after load so images/fonts don't affect the measurement.
  const containerHeight = pageTemplate.offsetHeight;
  const leafCount = Math.max(2, Math.min(6, Math.round(containerHeight / window.innerHeight)));

  // Start leaves after the first page section so they don't collide with
  // the ::before/::after patterns or the topper on short pages.
  const firstSection = pageTemplate.querySelector('main section');
  const containerTop = pageTemplate.getBoundingClientRect().top;
  const startPercent = firstSection
    ? Math.min(Math.ceil(((firstSection.getBoundingClientRect().bottom - containerTop) / containerHeight) * 100) + 2, 40)
    : 20;

  const endPercent = 85;
  const range = endPercent - startPercent;

  Array.from({ length: leafCount }, (_, i) => ({
    side: i % 2 === 0 ? 'right' : 'left',
    top: `${(startPercent + (range / Math.max(leafCount - 1, 1)) * i).toFixed(1)}%`,
    floatDelay: `-${(i * 2.7 % 8).toFixed(1)}s`,
  })).forEach(({ side, top, floatDelay }) => {
    const leaf = document.createElement('div');
    leaf.className = `page-leaf page-leaf--${side}`;
    leaf.setAttribute('aria-hidden', 'true');
    leaf.style.top = top;
    leaf.style.setProperty('--leaf-float-delay', floatDelay);
    pageTemplate.appendChild(leaf);
    observer.observe(leaf);
  });
});
